const SvgSend = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m2.667 18.667 18.667-2.489v-.355L2.667 13.334l.013-9.333 27.987 12-27.987 12zm1.335-6.501 18.841 2.512v2.643L4.002 19.833l.009 6.145 23.273-9.979L4.011 6.02z" />
  </svg>;
export default SvgSend;